import MainContainer from "../MainContainer";
import DirectionHandler from "../DirectionHandler";
import { AppRoutes } from "../../constants";
import { selectIsLoggedIn } from "../../AppSlice";
import { useAppDispatch, useAppSelector } from "../../redux";
import { loginAdminAction, loginReturningAdminAction } from "../Dashboard/DashboardSlice";
import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@mui/icons-material";
import { useState, useEffect, type ChangeEvent, type FormEvent } from "react";
import { Box, Button, Checkbox, TextField, FormControlLabel } from "@mui/material";

export default function _AdminLogin() {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  const [attemptedLogin, setAttemptedLogin] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    const start = async () => {
      async function getData() {
        if (!attemptedLogin) {
          await dispatch(loginReturningAdminAction());

          setAttemptedLogin(true);
        }
      }

      await getData();
    };

    start();
  }, [attemptedLogin]);

  useEffect(() => {
    if (isLoggedIn) navigate(AppRoutes.adminPanel);
  }, [isLoggedIn]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked, value } = event.currentTarget;

    switch (name) {
      case "username":
        return setUserName(value);

      case "password":
        return setPassword(value);

      case "rememberMe":
        return setRememberMe(checked);

      default:
        return;
    }
  };

  const handleLogin = async (event: FormEvent) => {
    event.preventDefault();

    await dispatch(
      loginAdminAction({
        username,
        password,
        rememberMe,
      })
    );
  };

  return attemptedLogin ? (
    <DirectionHandler>
      <MainContainer avatar={<LockOutlined />} title="Admin panel login" titleVariant="h5">
        <Box component="form" onSubmit={handleLogin} sx={{ width: "25%" }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Username"
            name="username"
            value={username}
            onChange={handleInputChange}
            autoFocus
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Password"
            name="password"
            value={password}
            onChange={handleInputChange}
            type="password"
          />

          <FormControlLabel
            control={<Checkbox name="rememberMe" color="primary" checked={rememberMe} onChange={handleInputChange} />}
            label="Remember me"
          />

          <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 1 }}>
            Sign In
          </Button>
        </Box>
      </MainContainer>
    </DirectionHandler>
  ) : null;
}
